import {isPlatformBrowser} from '@angular/common';
import {ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {Router} from '@angular/router';
import {TaxInformationValidationService} from '@app/digital-native-checkout/tax-information/services/validation.service';
import {AttachedDocumentsModel} from '@app/model/attached-documents.model';
import {CountryBpTaxConfig} from '@app/model/dcp-config-service/tax-config';
import {AddressUsage, CheckoutReviewOrderComponentTexts} from '@app/model/order/dcp-order-entry.model';
import {PaymentMode, PaymentTypeCode} from '@app/model/order/dcp-order.model';
import {TemplateView} from '@app/model/template-view.model';
import {DcpCcPspService} from '@app/payment/services/dcp-cc-psp.service';
import {PaymentModeService} from '@app/payment/services/payment-mode.service';
import {DcpCartService} from '@app/product/services/dcp-cart.service';
import {EddlCheckoutStartEvent} from '@app/services/analytics/EDDL/events/eddl-checkout-start-event';
import {B2bUnitService} from '@app/services/b2b-unit.service';
import {ComponentService} from '@app/services/component.service';
import {DcpActiveCartService} from '@app/services/dcp-active-cart.service';
import {DcpConfigService} from '@app/services/dcp-config.service';
import {DcpCustomerRegistrationDecoratorService} from '@app/services/dcp-customer-registration-decorator.service';
import {DcpOrderEntryService} from '@app/services/dcp-order-entry.service';
import {ORDER_REVIEW_ACCORDION_LOCALSTORAGE_KEY_PREFIX} from '@app/services/local-storage.constants';
import {TransactionTypeCode} from '@app/services/transactionTypes/transaction-type-code';
import {TransactionTypeService} from '@app/services/transactionTypes/transaction-type.service';
import {DcpUserService} from '@app/services/user/dcp-user.service';
import {DcpEntryGroup, DcpGlobalMessageService, JsonService, LocalStorageService} from '@dcp/configurator';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {ActiveCartService} from '@spartacus/cart/base/core';
import {ActiveCartFacade, Cart, CartRemoveEntrySuccessEvent, PaymentType} from '@spartacus/cart/base/root';
import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';
import {CheckoutPaymentTypeService} from '@spartacus/checkout/b2b/core';
import {B2BPaymentTypeEnum} from '@spartacus/checkout/b2b/root';
import {CheckoutReviewSubmitComponent, CheckoutStepService} from '@spartacus/checkout/base/components';
import {CheckoutDeliveryAddressFacade, CheckoutDeliveryModesFacade, CheckoutPaymentFacade} from '@spartacus/checkout/base/root';
import {EventService, GlobalMessageType, RoutingService, TranslationService, User} from '@spartacus/core';
import {Address} from '@spartacus/core/src/model/address.model';
import {CmsComponentData} from '@spartacus/storefront';
import {Observable, Subscription, throwError} from 'rxjs';
import {catchError, first, map, take} from 'rxjs/operators';
import {OrderHistoryProcessingErrorService} from '../error-handling/order-history-processing-error/order-history-processing-error.service';
import {CmsFlexComponentData} from '../order-confirmation/order-confirmation-list-item/order-confirmation-order-item.model';
import {OrderItemService} from '../order-item/services/order-item.service';
import {CartDecoratorErrorHandlingService} from '../services/cart-decorator-error-handling.service';
import {CheckoutErrorHandlingService} from '../services/checkout-error-handling.service';
import {TransactionTypeDataService} from '../services/transaction-type-data.service';

@UntilDestroy()
@Component({
  selector: 'dcp-review-submit',
  templateUrl: './dcp-review-submit.component.html',
})
export class DcpReviewSubmitComponent extends CheckoutReviewSubmitComponent implements OnInit, OnDestroy {

  public isPlatformBrowser: boolean = false;
  public componentData$: Observable<CmsFlexComponentData>;
  public componentTexts: CheckoutReviewOrderComponentTexts;
  public cartEntries$: Observable<OrderEntry[]>;
  public cartEntryGroups: DcpEntryGroup[];
  public view = TemplateView;
  public paymentModes: PaymentMode[];
  public hideReviewSubmitContent: boolean = false;
  public isVisibleDisposableBlock: boolean = false;
  public cartEntryGroupsSubscription = new Subscription();
  public showCartHeaderSection: boolean = false;
  public addresses: Address[];
  public isCurrentUserIndividual: boolean;
  public paymentType: PaymentType;
  public documents: AttachedDocumentsModel[];
  public cartIsLoading: boolean = false;
  public currentUser: User;
  public isApiCallFailed: boolean = false;
  public showRemoveAction: boolean = true;
  countryIsoCode: string;

  get orderReviewAccordionLocalStorageKeyPrefix(): string {
    return ORDER_REVIEW_ACCORDION_LOCALSTORAGE_KEY_PREFIX;
  }

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private cmsData: CmsComponentData<CmsFlexComponentData>,
    private componentService: ComponentService,
    protected checkoutPaymentService: CheckoutPaymentFacade,
    protected activeCartService: ActiveCartService,
    protected translation: TranslationService,
    public checkoutErrorHandlingService: CheckoutErrorHandlingService,
    public transactionTypeService: TransactionTypeService,
    protected checkoutStepService: CheckoutStepService,
    public dcpGlobalMessageService: DcpGlobalMessageService,
    protected dcpActiveCartService: DcpActiveCartService,
    private cartService: DcpCartService,
    private paymentModesService: PaymentModeService,
    private orderItemService: OrderItemService,
    private transactionTypeDataService: TransactionTypeDataService,
    private changeDetectorRef: ChangeDetectorRef,
    private dcpUserService: DcpUserService,
    private dcpConfigService: DcpConfigService,
    protected localStorageService: LocalStorageService,
    private router: Router,
    public orderHistoryProcessingErrorService: OrderHistoryProcessingErrorService,
    private b2bUnitService: B2bUnitService,
    private jsonService: JsonService,
    private validationService: TaxInformationValidationService,
    private registrationService: DcpCustomerRegistrationDecoratorService,
    private eventService: EventService,
    private dcpOrderEntryService: DcpOrderEntryService,
    private cartDecoratorErrorHandlingService: CartDecoratorErrorHandlingService,
    protected paymentTypeService: CheckoutPaymentTypeService,
    private dcpCcPspService: DcpCcPspService,
    protected routingService: RoutingService,
    checkoutDeliveryAddressFacade: CheckoutDeliveryAddressFacade,
    activeCartFacade: ActiveCartFacade,
    checkoutDeliveryModesFacade: CheckoutDeliveryModesFacade,
  ) {
    super(
      checkoutDeliveryAddressFacade,
      checkoutPaymentService,
      activeCartFacade,
      translation,
      checkoutStepService,
      checkoutDeliveryModesFacade,
    );
    this.isPlatformBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.dcpCcPspService.subscribeToStripeDisclaimer();
    this.manageTaxSubscriptions();
    this.cartEntries$ = this.activeCartService.getEntries();
    this.mapComponentData();
    this.fetchPaymentModes();
    this.cart$.pipe(
      untilDestroyed(this)
    ).subscribe((cart: Cart) => {
      this.setCartData(cart);
      if (this.checkIsUpsellCart(cart)) {
        this.eventService.dispatch(new EddlCheckoutStartEvent());
      }
    });
    this.subscribeToEntryGroups();
    this.manageCartSubscription();
    this.subscribeToLoadingState();
    this.localStorageService.setItem('lastPage', this.router.url);
    this.checkEmptyCart();
    this.showRemoveAction = this.hasPermissionToRemove();
  }

  setCartData(cart: Cart) {
    this.setInvoicePaymentTypeForUpsell(cart);
    this.documents = cart.attachedDocuments ? cart.attachedDocuments : [];
    this.addresses = cart.addresses ? cart.addresses : [];
    this.paymentType = cart.paymentType;
    if (cart.entries) {
      this.showCartHeaderSection = cart.entries
        .reduce((acc, item: OrderEntry) => {
          const transactionType = item.product.transactionTypes
            .find((productTransactionType) => productTransactionType.code === item.transactionType);
          const config = this.transactionTypeDataService.getBlocksConf(transactionType?.data);
          return acc || (typeof config?.hideCartHeaderSection === 'boolean' && !config.hideCartHeaderSection);
        }, false);
      this.changeDetectorRef.detectChanges();
    }
  }

  setInvoicePaymentTypeForUpsell(cart: Cart) {
    if (cart?.paymentType?.code === PaymentTypeCode.ACCOUNT) {
      return;
    }

    if (this.checkIsUpsellCart(cart)) {
      this.paymentTypeService.setPaymentType(B2BPaymentTypeEnum.ACCOUNT_PAYMENT);
    }
  }

  private checkIsUpsellCart(cart: Cart) {
    return cart?.entries?.every((entry) => this.isUpsellProduct(entry));
  }

  isUpsellProduct(entry: OrderEntry): boolean {
    return !!this.dcpOrderEntryService.getReferencedDocuments(entry) && !this.isOrderRestructure(entry?.transactionType);
  }

  isOrderRestructure(transactionType: string): boolean {
    return transactionType === TransactionTypeCode.ORDER_RESTRUCTURE_UPGRADE;
  }

  get cart$(): Observable<Cart> {
    return this.checkoutErrorHandlingService.cartRequestErrorWrapper(this.activeCartService.getActive());
  }

  mapComponentData() {
    this.componentData$ = this.cmsData.data$;
    this.componentService.fetchClassificationsProductData(this.cmsData)
      .pipe(untilDestroyed(this))
      .subscribe(componentData => {
        this.componentTexts = componentData?.texts;
      });
  }

  fetchPaymentModes(): void {
    this.paymentModesService.fetchPaymentModes()
      .pipe(first(), untilDestroyed(this))
      .subscribe((paymentModes: PaymentMode[]) => this.paymentModes = paymentModes);
  }

  ngOnDestroy(): void {
    this.orderItemService.clearOrderItemCollapsedState();
    this.cartEntryGroupsSubscription.unsubscribe();
  }

  /**
   * Subscribes or unsubscribes to cart changes when the edit modal is opened.
   * If the cart is refreshed while the modal is opened the UI will be refreshed.
   * While refreshing the UI, the modal component will be destroyed and the modal will be closed.
   * This can be prevented by unsubscribing while the modal is opened.
   */
  manageCartSubscription() {
    this.cartService.cartSubscriptionStatus
      .pipe(untilDestroyed(this))
      .subscribe(s => {
        if (s === 'subscribe') {
          this.subscribeToEntryGroups();
        } else {
          this.cartEntryGroupsSubscription.unsubscribe();
        }
      });
  }

  subscribeToEntryGroups() {
    // Subscription.add caused the view not to be updated with current cart data.
    this.cartEntryGroupsSubscription.unsubscribe();
    this.cartEntryGroupsSubscription = this.dcpActiveCartService.getEntryGroups().pipe(untilDestroyed((this))).subscribe(
      eg => this.cartEntryGroups = eg
    );
  }

  showPaymentAccordion(entry: OrderEntry): Observable<boolean> {
    return this.dcpConfigService.getCommercialModelConfig(entry?.product, entry?.transactionType)
      .pipe(first(), map(commercialModelConfig => commercialModelConfig.showPaymentAccordion), untilDestroyed(this));
  }

  skipTaxIdValidation(cart: Cart): boolean {
    let skipTaxIdValidation = false;
    for (const entry of cart.entries) {
      this.dcpConfigService.getCommercialModelConfig(entry?.product, entry?.transactionType)
        .pipe(first(), untilDestroyed(this))
        .subscribe(commercialModelConfig => {
          skipTaxIdValidation = commercialModelConfig.skipTaxIdValidation;
        });
      if (skipTaxIdValidation) break;
    }
    return skipTaxIdValidation;
  }

  /**
   * displays a skeleton loading indicator as long as the cart is reloading.
   */
  subscribeToLoadingState() {
    this.activeCartService.getLoading().pipe(untilDestroyed(this)).subscribe(isLoading => {
      this.cartIsLoading = isLoading;
      this.changeDetectorRef.detectChanges();
    });
  }

  /**
   * Tax related functions.
   * The tax id validation does not happen if any of the following conditions is true
   * - the cart is fully upsell
   * - the tax id is stored on the b2b unit
   * - the country configuration doesn't require tax id
   * - the cart is an SBN cart
   */
  manageTaxSubscriptions() {
    this.cart$
      .pipe(take(1), untilDestroyed(this))
      .subscribe((cart: Cart) => {
        if (!this.skipTaxIdValidation(cart)) {
          this.registrationService.getCurrentUserWithJson().pipe(first(Boolean), untilDestroyed(this)).subscribe((user: User) => {
            this.isCurrentUserIndividual = this.dcpUserService.isUserCompanyTypeIndividual(user);
            if (!this.checkIsUpsellCart(cart)) {
              this.b2bUnitService.getB2bUnitByUserAndB2bUnitId(user.uid, user.orgUnit.uid).pipe(catchError((e) => this.genericErrorHandler(e)), untilDestroyed(this))
                .subscribe(b2bUnit => {
                  //check here whether the b2bUnit has the taxId, if yes, don't go further.
                  const soldToAddress: any = b2bUnit.addresses?.find(address => AddressUsage.SOLD_TO === address.addressUsage?.trim().toUpperCase());
                  if (!soldToAddress?.taxID && !b2bUnit.taxID) {
                    this.validateTaxId(user);
                  }
                });
            }
          });
        }
      });
  }

  validateTaxId(user: User) {
    this.dcpConfigService.getRequiredTaxIds(this.validationService.mapCountryBpTaxPayload(user))
      .pipe(untilDestroyed(this))
      .subscribe((bpTaxConfig: CountryBpTaxConfig) => {
        if (bpTaxConfig.taxIdRequiredForBilling) {
          this.dcpConfigService
            .validateTaxIds(this.validationService.getCurrentTaxValidationPayload(bpTaxConfig.taxType, this.resolveTaxNumber(user), user))
            .pipe(untilDestroyed(this))
            .subscribe(() => { // validation ok, nothing to do here
              },
              errorResponse => {
                // firing a disposable msg in case of failed validation
                this.translation
                  .translate('checkout.digitalNativeCheckout.tax.errors.taxValidationReviewOrder')
                  .pipe(first(), untilDestroyed(this))
                  .subscribe((message) => {
                    this.dcpGlobalMessageService.addMessage({
                        message,
                        errorCode: errorResponse.status,
                        type: GlobalMessageType.MSG_TYPE_ERROR
                      },
                      this.constructor.name, 'errorGlobal');
                  });
                this.cartDecoratorErrorHandlingService.disablePlaceOrder();
                this.changeDetectorRef.detectChanges();
              });
        }
      });
  }

  resolveTaxNumber(user: User): string {
    const taxDataJsonValue = user.json?.find(json => json.type === 'taxData')?.value;
    return this.jsonService.parseSafely(taxDataJsonValue)?.taxId;
  }

  private genericErrorHandler(e) {
    this.isApiCallFailed = true;
    this.changeDetectorRef.detectChanges();
    return throwError(e);
  };

  checkEmptyCart(): void {
    this.eventService.get(CartRemoveEntrySuccessEvent).pipe(untilDestroyed(this)).subscribe(() => {
      this.cartEntries$
        .pipe(untilDestroyed(this))
        .subscribe((entries) => {
            if (entries.length == 0) {
              this.routingService.go({cxRoute: 'cart'});
            }
          }
        )
    })
  }

  hasPermissionToRemove(): boolean {
    const permissionsData = this.localStorageService.getItem('permissionsData');
    return !permissionsData || JSON.parse(permissionsData)?.userGroups?.[0]?.permissions.some(p => p.name === 'remove-from-cart');;
  }
}
